import React from 'react';
import { Card, Typography, Tag, Space, Progress } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { GenerateCopyResult } from '../../../types';

const { Text } = Typography;

interface KeywordCoverage {
    keywords: Array<{
        keyword: string;
        total_count: number;
        in_title: boolean;
        in_bullets: number[];
    }>;
}

interface KeywordSummaryProps {
    coverage: KeywordCoverage | null;
}

export const KeywordSummary: React.FC<KeywordSummaryProps> = ({ coverage }) => {
    if (!coverage) return null;

    const coveredCount = coverage.keywords.filter(k => k.total_count > 0).length;
    const totalCount = coverage.keywords.length;
    const percentage = totalCount > 0 ? Math.round((coveredCount / totalCount) * 100) : 0;

    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <Space>
                    <Tag color="gold">关键词覆盖率</Tag>
                    <Text strong>{coveredCount}/{totalCount} 个关键词</Text>
                </Space>
                <Progress
                    percent={percentage}
                    size="small"
                    style={{ width: 120, margin: 0 }}
                    status={percentage >= 80 ? 'success' : percentage >= 50 ? 'normal' : 'exception'}
                />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {coverage.keywords.map((kw, idx) => (
                    <Tag
                        key={idx}
                        icon={kw.total_count > 0 ? <CheckCircleOutlined /> : <WarningOutlined />}
                        color={kw.total_count > 0 ? 'success' : 'default'}
                    >
                        {kw.keyword}
                        {kw.in_title && <Text type="secondary" style={{ marginLeft: 4 }}>(标题)</Text>}
                        {kw.in_bullets.length > 0 && <Text type="secondary" style={{ marginLeft: 4 }}>(BP{kw.in_bullets.map(i => i + 1).join(',')})</Text>}
                    </Tag>
                ))}
            </div>
        </Card>
    );
};
